import {
  ClusterStats,
  Daily,
  Device,
  DeviceDTO,
  clusterStatsFromDTO,
  deviceFromDTO
} from '@/lib/types'

import { fetchAPI } from '.'

export async function getAllDevices({ page }: { page: number }): Promise<{
  devices: Device[]
  total: number
}> {
  const { devices, total } = await fetchAPI('GET', 'cluster/devices', { page })

  return {
    devices: devices?.map((device: DeviceDTO) => deviceFromDTO(device)),
    total
  }
}

export async function getDevice({ id }: { id: number }): Promise<Device> {
  const data = await fetchAPI('GET', `cluster/devices/${id}`)

  return deviceFromDTO(data)
}

export async function sellDevice({
  id,
  hashrate,
  deviceCount,
  csrfToken,
  price,
  currency,
  instant
}: {
  id: number
  hashrate?: number
  deviceCount?: number
  csrfToken: string
  price?: number
  currency?: string
  instant: boolean
}): Promise<void> {
  await fetchAPI(
    'POST',
    `cluster/devices/${id}/sell`,
    {},
    {
      csrf_token: csrfToken,
      instant,
      device_count: deviceCount,
      hashrate,
      ...(!instant && { price: (price as number) * 100, currency })
    }
  )
}

export async function disableDevice({
  id,
  csrfToken
}: {
  id: number
  csrfToken: string
}): Promise<void> {
  await fetchAPI(
    'POST',
    `cluster/devices/${id}/disable`,
    {},
    { csrf_token: csrfToken }
  )
}

export async function enableDevice({
  id,
  csrfToken
}: {
  id: number
  csrfToken: string
}): Promise<void> {
  await fetchAPI(
    'POST',
    `cluster/devices/${id}/enable`,
    {},
    { csrf_token: csrfToken }
  )
}

export async function getClusterStats(): Promise<ClusterStats> {
  const data = await fetchAPI('GET', 'cluster/stats')

  return clusterStatsFromDTO(data)
}

export async function getEstimateInstantSale({
  id,
  hashrate,
  deviceCount
}: {
  id: number
  hashrate?: number
  deviceCount?: number
}): Promise<{ price: number }> {
  return await fetchAPI(
    'POST',
    `cluster/devices/${id}/estimate_instant_sale`,
    {},
    {
      ...(hashrate && { hashrate }),
      ...(deviceCount && { device_count: deviceCount })
    }
  )
}

export async function getDeviceStats({
  id,
  page
}: {
  id: number
  page: number
}): Promise<{ days: Daily[]; total: number }> {
  return await fetchAPI('GET', `cluster/devices/${id}/stats/daily`, { page })
}

export async function getClusterDailyStats({
  page
}: {
  page: number
}): Promise<{ days: Daily[]; total: number }> {
  return await fetchAPI('GET', `cluster/stats/daily`, { page })
}
